module.exports = __webpack_public_path__ + "static/media/feature3.6585d260.png";